import { render } from "./SelectedProducts.vue?vue&type=template&id=3689a9b0&scoped=true&ts=true"
import script from "./SelectedProducts.vue?vue&type=script&lang=ts"
export * from "./SelectedProducts.vue?vue&type=script&lang=ts"

import "./SelectedProducts.vue?vue&type=style&index=0&id=3689a9b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3689a9b0"]])

export default __exports__